import { graphql } from "gatsby";
import React from "react";
import ButtonLink from "./link/ButtonLink";
import { classes, StyledEmbeddedLink } from "./styles/EmbeddedLink.styles";
import type {
  RichTextAssetLinkBlock,
  RichTextCalculatorLinkBlock,
  RichTextDialogLinkBlock,
  RichTextExternalLinkBlock,
  RichTextHubSpotLinkBlock,
  RichTextInternalLinkBlock,
  RichTextVisualiserLinkBlock
} from "./link/types";

type Props = {
  fields:
    | RichTextInternalLinkBlock
    | RichTextExternalLinkBlock
    | RichTextAssetLinkBlock
    | RichTextHubSpotLinkBlock
    | RichTextDialogLinkBlock
    | RichTextCalculatorLinkBlock
    | RichTextVisualiserLinkBlock;
  theme?: "primary" | "secondary";
  backgroundTheme?: "light" | "dark";
  gtmLabel?: React.ReactNode;
};

const EmbeddedLink = ({
  fields,
  theme = "primary",
  backgroundTheme = "light",
  gtmLabel
}: Props) => {
  return (
    <StyledEmbeddedLink>
      <ButtonLink
        data={fields}
        variant={theme === "primary" ? "contained" : "opaqueOutlined"}
        hasDarkBackground={backgroundTheme === "dark"}
        className={classes.embeddedLink}
        gtm={{
          label: gtmLabel ? `${gtmLabel} - ${fields.label}` : fields.label
        }}
      >
        {fields.label}
      </ButtonLink>
    </StyledEmbeddedLink>
  );
};

export default EmbeddedLink;

export const query = graphql`
  fragment EmbeddedLinkFragment on PayloadLink {
    __typename
    #    contentful_id
    ...LinkFragment
  }
`;
